module.exports = __webpack_public_path__ + "static/media/JakeOptimized.f879cf64.jp2";